import { render, staticRenderFns } from "./consultores.vue?vue&type=template&id=5da78c4c&scoped=true&"
import script from "./consultores.vue?vue&type=script&lang=js&"
export * from "./consultores.vue?vue&type=script&lang=js&"
import style0 from "./consultores.vue?vue&type=style&index=0&id=5da78c4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da78c4c",
  null
  
)

export default component.exports